module.exports = __webpack_public_path__ + "img/icon-6.7e89f983.png";